import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PricingWidget } from './components/PricingWidget';
import { MarketOpportunity } from './components/MarketOpportunity';
import { WhatIsSection } from './components/WhatIsSection';
import { AchievementsSection } from './components/AchievementsSection';
import { ContentBreakdown } from './components/ContentBreakdown';
import { IncomePotential } from './components/IncomePotential';
import { BonusesSection } from './components/BonusesSection';
import { TimelineSection } from './components/TimelineSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code - safe injection for SPA environments
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '832917643091578');
    window.fbq('track', 'PageView');
    // Track AddToCart on all cart buttons
    const handleAddToCart = () => {
      if (window.fbq) {
        window.fbq('track', 'AddToCart');
      }
    };
    // Attach listeners to all cart links
    const links = document.querySelectorAll('a[href*="pagos.avanzalab.online"]');
    links.forEach(link => {
      link.addEventListener('click', handleAddToCart);
    });
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleAddToCart);
      });
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] font-sans text-white selection:bg-amber-500/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PricingWidget data-id="element-2" />
      <MarketOpportunity data-id="element-3" />
      <WhatIsSection data-id="element-4" />
      <AchievementsSection data-id="element-5" />
      <ContentBreakdown data-id="element-6" />
      <IncomePotential data-id="element-7" />
      <BonusesSection data-id="element-8" />
      <PricingWidget data-id="element-9" /> {/* Second Pricing Section */}
      <TimelineSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
      {/* Footer simple */}
      <footer className="bg-black text-gray-600 py-8 text-center text-sm border-t border-gray-800" data-id="element-15">
        <p data-id="element-16">© 2026 Mega Pack Pisos Epoxi Pro. Todos los derechos reservados.</p>
      </footer>
    </div>;
}